import { OrderProduct } from "modules/orders";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RefundType } from "../../../../../constants";
import {
  EarningsBlockProps,
  RefundPaymentDetailsProps
} from "./RefundPaymentDetails.types";

import styles from "./RefundPaymentDetails.module.scss";

const RefundPaymentDetails = ({ refund }: RefundPaymentDetailsProps) => {
  const { t } = useTranslation();

  const itemsList = useMemo(() => {
    return refund.type === RefundType.OrderReturn
      ? refund.order.items.filter(
          (item) => item.quantityThatCannotBeReplaced > 0
        )
      : refund.order.items;
  }, [refund]);

  const EarningsBlock = ({
    title,
    prevValue = 0,
    newValue = 0,
    color = "#03BF9D"
  }: EarningsBlockProps) => {
    return (
      <div className={styles.earnings}>
        <p className={styles.earnings__title}>{t(`Previous ${title}`)}</p>
        <p className={styles["earnings__value--prev"]} style={{ color }}>
          {prevValue.toLocaleString("en-US") ?? 0} FCFA
        </p>
        <p className={styles.earnings__title}>{t(`New ${title}`)}</p>
        <p className={styles["earnings__value--new"]} style={{ color }}>
          {newValue.toLocaleString("en-US") ?? 0} FCFA
        </p>
      </div>
    );
  };

  return (
    <div className={styles.refund}>
      <div className={styles.refund__payment}>
        <p className={styles["refund__payment--title"]}>
          {t("Earnings breakdown")}
        </p>

        <div className={styles["refund__payment--earnings"]}>
          <EarningsBlock
            title="Commission"
            prevValue={refund.details.previousCommission}
            newValue={refund.details.newCommission}
          />
          <EarningsBlock
            title="Margin"
            prevValue={refund.details.previousMargin}
            newValue={refund.details.newMargin}
            color="#FB3973"
          />
        </div>

        <div className={styles["refund__payment--details"]}>
          <div className={styles["refund__payment--separator"]} />

          <div className={styles.refund__details}>
            <p className={styles["refund__details--title"]}>
              {t("Refund Total")}
            </p>
            <p className={styles["refund__details--amount"]}>
              {refund.amount.toLocaleString("en-US")} FCFA
            </p>
          </div>
        </div>
      </div>

      <div className={styles.refund__products}>
        <p className={styles["refund__products--title"]}>
          {refund.type === RefundType.OrderReturn
            ? t("Can't be replaced items")
            : t("Order items")}
        </p>

        {itemsList.map((item) => (
          <OrderProduct
            key={item.id}
            item={item}
            className={styles["refund__products--item"]}
          />
        ))}
      </div>
    </div>
  );
};

export default RefundPaymentDetails;
